import { Text } from "../."

interface UserIconProps {
	displayName: string
	url?: string
}

export const UserIcon = ({ displayName, url }: UserIconProps) => {
	if (url && url.length !== 0) {
		return <img src={url} className="h-16 w-16 rounded-full" />
	}

	return (
		<div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#0f0f0f]">
			<Text style="text-lg uppercase">
				{displayName
					.split(" ")
					.map((s) => s[0])
					.join("")}
			</Text>
		</div>
	)
}
